/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventSearchOptions_eventSearchOptionsInfo$ref = any;
type InactiveEventInfo_eventInfo$ref = any;
type PresaleEventInfo_eventPresaleInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventAvailableSearchActions_info$ref: FragmentReference;
declare export opaque type EventAvailableSearchActions_info$fragmentType: EventAvailableSearchActions_info$ref;
export type EventAvailableSearchActions_info = {|
  +mainSearch: ?string,
  +sgId: ?number,
  +presaleMessage: ?string,
  +presale: ?string,
  +gps: ?boolean,
  +searchDual: ?boolean,
  +searchCollections: ?boolean,
  +participantUser: ?boolean,
  +secondFactorType: ?{|
    +type: ?string
  |},
  +$fragmentRefs: PresaleEventInfo_eventPresaleInfo$ref & EventSearchOptions_eventSearchOptionsInfo$ref & InactiveEventInfo_eventInfo$ref,
  +$refType: EventAvailableSearchActions_info$ref,
|};
export type EventAvailableSearchActions_info$data = EventAvailableSearchActions_info;
export type EventAvailableSearchActions_info$key = {
  +$data?: EventAvailableSearchActions_info$data,
  +$fragmentRefs: EventAvailableSearchActions_info$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EventAvailableSearchActions_info",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainSearch",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sgId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "presaleMessage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "presale",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gps",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searchDual",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "searchCollections",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "participantUser",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "secondFactorType",
      "storageKey": null,
      "args": null,
      "concreteType": "SecondFactorType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PresaleEventInfo_eventPresaleInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "EventSearchOptions_eventSearchOptionsInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "InactiveEventInfo_eventInfo",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd964a2e29155229eb446d07265d67f80';

module.exports = node;
